var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('LoadedContent',{attrs:{"loading":_vm.imageLoading,"skeleton-type":"badge"}},[_c('router-link',{attrs:{"to":_vm.badge.url}},[_c('img',{staticClass:"badge",class:_vm.badge.type,attrs:{"src":_vm.badge.badge,"alt":"badge","title":_vm.localizeString(_vm.badge.name, _vm.context.user)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }